import {
    Agriculture,
    ArticleOutlined,
    Dashboard,
  } from "@mui/icons-material";
  
  export const spvMenu = [
    {
      title: "Dashboard",
      icon: <Dashboard />,
      path: "/admin",
      items: [],
    },
    {
      title: "Aktifitas Harian",
      icon: <Agriculture />,
      path: "/petani/aktifitas-harian",
      items: [],
    },
    {
      title: "Estimasi Panen",
      icon: <Agriculture />,
      path: "/petani/estimasi-panen",
      items: [],
    },
    {
      title: "Panen",
      icon: <Agriculture />,
      path: "/petani/panen",
      items: [],
    },
    {
      title: "Nota Petani",
      icon: <ArticleOutlined />,
      path: "/petani/nota-petani",
      items: [],
    },
    {
        title: "Laporan",
        icon: <ArticleOutlined />,
        items: [
          {
            title: "Aktifitas Petani",
            items: [
              {
                title: "Beraktifitas",
                path: "/spv/laporan/aktifitas-petani/beraktifitas",
              },
              {
                title: "Detail",
                path: "/spv/laporan/aktifitas-petani/detail",
              },
              {
                title: "Tidak Beraktifitas",
                path: "/spv/laporan/aktifitas-petani/tidak-beraktifitas",
              },
              {
                title: "Semua Petani",
                path: "/spv/laporan/aktifitas-petani",
              },
            ],
          },
          {
            title: "Estimasi Panen",
            items: [
              {
                title: "Estimasi Panen",
                path: "/spv/laporan/estimasi-panen",
              },
              {
                title: "Estimasi Panen Petani",
                path: "/spv/laporan/estimasi-panen/petani",
              },
            ],
          },
          {
            title: "Panen",
            items: [
              {
                title: "Panen",
                path: "/spv/laporan/panen",
              },
              {
                title: "Panen Petani",
                path: "/spv/laporan/panen/petani",
              },
            ],
          },
        ],
      },
  ];
  